export const singleTags = {
    lineBreak: '<br>',
    conditionalLineBreak: '<span class="dv-conditional-linebreak"><br></span>',

    // entities
    trademark: '<sup>&trade;</sup>',
    registeredTrademark: '<sup>&reg;</sup>',
    copyright: '&copy;',
    ellipsis: '&hellip;',
  }

  export const openInlineTags = {
    bold: 'strong',
    italic: 'em',
    small: 'small',
    strike: 'strike',
    noWrap: 'span',
    link: 'a',
  }

  export const openBlockTags = {
    paragraph: 'p',
    unorderedList: 'ul',
    listItem: 'li'
  }

  export const closeTags = {
    bold: '</strong>',
    italic: '</em>',
    small: '</small>',
    strike: '</strike>',
    noWrap: '</span>',
    paragraph: '</p>',
    link: '</a>',
    unorderedList: '</ul>',
    listItem: '</li>'
  }
